const VIP_TAG = 'vip';
const VIP_BOX_HEIGHT_PX = 20;
// Deep purple — distinct from orange route pins and yellow map labels.
const VIP_BOX_FILL = '#6A1B9A';

export const orderHasVIPTag = (order) =>
    (order?.tags || []).some(({ tag }) => tag.tag?.toLowerCase() === VIP_TAG);

export const stopHasVIPOrder = (stop, ordersById) => {
    return stop.orders?.some((orderId) => orderHasVIPTag(ordersById?.[orderId]));
};

export const addVIPBoxToSVG = (svg) => {
    const svgWidthMatch = svg.match(/<svg[^>]*\bwidth=['"]([^'"]+)['"]/);
    const svgHeightMatch = svg.match(/<svg[^>]*\bheight=['"]([^'"]+)['"]/);
    const svgWidth = svgWidthMatch ? parseFloat(svgWidthMatch[1]) : 27;
    const svgHeight = svgHeightMatch ? parseFloat(svgHeightMatch[1]) : 33;

    const viewBoxMatch = svg.match(/viewBox=['"]([^'"]+)['"]/);
    let minX = 0,
        minY = 0,
        vbWidth = svgWidth,
        vbHeight = svgHeight;
    if (viewBoxMatch) {
        const parts = viewBoxMatch[1].split(' ');
        minX = parseFloat(parts[0]);
        minY = parseFloat(parts[1]);
        vbWidth = parseFloat(parts[2]);
        vbHeight = parseFloat(parts[3]);
    }

    const scale = vbHeight / svgHeight;
    const boxHeightVB = VIP_BOX_HEIGHT_PX * scale;
    const newSvgHeight = svgHeight + VIP_BOX_HEIGHT_PX;
    const newVbHeight = vbHeight + boxHeightVB;
    const newViewBox = `${minX} ${minY} ${vbWidth} ${newVbHeight}`;

    const boxWidth = vbWidth - 4;
    const boxX = minX + 2;
    const rx = Math.round(4 * scale);

    let wrappedSvg = `<svg width='${svgWidth}' height='${newSvgHeight}' viewBox='${newViewBox}' fill='none' xmlns='http://www.w3.org/2000/svg'>`;
    wrappedSvg += `<rect x='${boxX}' y='${minY}' width='${boxWidth}' height='${boxHeightVB}' fill='${VIP_BOX_FILL}' rx='${rx}'/>`;
    wrappedSvg += `<text x='${boxX + boxWidth / 2}' y='${minY + boxHeightVB / 2}' font-size='${Math.round(
        13 * scale
    )}' font-weight='bold' fill='white' text-anchor='middle' dominant-baseline='middle' font-family='Montserrat'>VIP</text>`;
    wrappedSvg += `<g transform='translate(0, ${boxHeightVB})'>`;

    const contentMatch = svg.match(/<svg[^>]*>([\s\S]*)<\/svg>/);
    if (contentMatch) {
        wrappedSvg += contentMatch[1];
    }
    wrappedSvg += `</g></svg>`;

    return wrappedSvg;
};

// Wraps a data:image/svg+xml,... URL with the VIP box and returns a new data URL.
export const wrapDataURLWithVIP = (dataURL) => {
    const match = dataURL?.match?.(/^(data:image\/svg\+xml(?:;charset=UTF-8)?,)([\s\S]*)$/i);
    if (!match) return dataURL;

    const prefix = match[1];
    const encoded = match[2];
    const decoded = decodeURIComponent(encoded);
    const wrapped = addVIPBoxToSVG(decoded);
    const reEncoded = wrapped.replace(/#/g, '%23').replace(/</g, '%3C').replace(/>/g, '%3E');
    return prefix + reEncoded;
};

export const VIP_BOX_HEIGHT = VIP_BOX_HEIGHT_PX;
